export const messages = {
  title: {
    id: 'admin/promotions.utils.unauthorized.title',
  },
}
